import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User, UserMap } from '../../types';
import { RootState } from '../store';

interface UserState {
  users: UserMap;
}

const initialState: UserState = {
  users: {},
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUsers: (state, action: PayloadAction<User[]>) => {
      const users: UserMap = {};
      for (const user of action.payload) {
        users[user.id] = user;
      }
      state.users = users;
    },
  },
});

export const { setUsers } = userSlice.actions;

export const selectUsers = (state: RootState) => state.user.users;

export const selectUsersList = createSelector(selectUsers, (map) =>
  Object.values(map).sort((u1, u2) => u1.username.localeCompare(u2.username))
);

export default userSlice.reducer;
